import { render, staticRenderFns } from "./TheLegend.vue?vue&type=template&id=59949f90&scoped=true&"
import script from "./TheLegend.vue?vue&type=script&lang=js&"
export * from "./TheLegend.vue?vue&type=script&lang=js&"
import style0 from "./TheLegend.vue?vue&type=style&index=0&id=59949f90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59949f90",
  null
  
)

export default component.exports